<template>
  <div class="bg-[#23242A] text-white h-screen appheader overflow-y-auto px-6 pt-6  pb-[170px]">
    <Nav/>

    <div class="p-3 bg-[#2B2C32] border-0 rounded-lg">
        <div class="mb-3 flex justify-between">
          <h3 class="text-[24px] text-white font-semibold">Earning Points</h3>
        </div>

        <block-loading v-if="loadingEarning"/>

       
          <template v-else>

            <template v-if="loyaltyProgram && loyaltyProgram.id">
          
            <div class="flex gap-3 xl:flex-row flex-col items-start mb-5">
              <div class="w-full xl:w-1/4">
            
                <div class="input-wrapper ">
                  <div :class="'input-wrapper ' + (form.points_per_dollar.error_type)">
                    <label class="block text-white text-xs" for="name">Earning Rate</label>
                    <div class="relative">
                      <input :disabled="!is_super_user" v-model.number="form.points_per_dollar.value"  @keyup="validateFields(['points_per_dollar'])" class="rounded border-none pr-[50px] w-full py-2.5 bg-[#464851] text-white tracking-wider leading-tight focus:outline-none focus:shadow-outline text-sm"  placeholder="1,000" type="number">
                      <span class="absolute flex bottom-2 right-2 text-base font-semibold tracking-wider">= $1</span>
                    </div>
                    <p class="field-error label-text mt-1" v-if="form.points_per_dollar.error_message" v-text="form.points_per_dollar.error_message"></p>
                  </div>
                  <div class="flex mt-1">
                    <span class="text-xs font-normal break-normal text-theme-878686 tracking-wider">You can't change your earning rate for points from here. Please contact your account manager to make changes</span>
                  </div>
                  <div class="flex mt-2">
                    <span class="text-xs font-normal break-normal text-theme-878686 tracking-wider">Make sure to update FAQ/Loyalty Terms if you are changing your earning rate</span>
                    
                    <span> <mdicon  size="20" name="alert-circle-outline" class=""/></span>
                  </div>
                </div>
              </div>

              <div class="w-full xl:w-1/4">
                <div :class="'input-wrapper ' + (form.min_purchase_amount.error_type)">
                  <label class="block text-white text-xs" for="name">Minimum Purchase Total</label>
                  <div class="relative">
                    <span class="absolute bottom-2.5 left-1.5"><mdicon  size="20" name="currency-usd" class=""/></span>
                    <input v-model.number="form.min_purchase_amount.value" @keyup="validateFields(['min_purchase_amount'])" class="rounded border-none w-full pl-6 py-2.5 bg-[#464851] text-white tracking-wider leading-tight focus:outline-none focus:shadow-outline text-sm"  placeholder="100,000" type="number">
                  </div>
                  <p class="field-error label-text mt-1" v-if="form.min_purchase_amount.error_message" v-text="form.min_purchase_amount.error_message"></p>
                </div>
              </div>

              <div class="w-full xl:w-1/4">
                <div :class="'input-wrapper ' + (form.earn_on.error_type)">
                  <label class="block text-white text-xs tracking-[0.4px]">Earn On</label>
                  <select :disabled="!is_super_user" @onchange="validateFields(['earn_on'])" v-model="form.earn_on.value" name="action-type" class="block tracking-wider border-none rounded bg-gray-black w-full text-white text-sm">
                    <option value="item">Item</option>
                    <option value="cart">Cart</option>
                  </select>
                  <p class="field-error label-text mt-1" v-if="form.earn_on.error_message" v-text="form.earn_on.error_message"></p>
                </div>
              </div>

              <div class="w-full xl:w-1/4">
                <div class="input-wrapper">
                  <label class="block text-white text-xs tracking-[0.4px]">Reward Accessories Only</label>
                  <label class="flex items-center cursor-pointer mt-2" :class="can_edit_membership_details ? '' : 'pointer-events-none'">
                    <input type="checkbox" v-model="form.reward_accessories_only" :disabled="!can_edit_membership_details" class="hidden peer">
                    <div :class="'relative toggle-bg border-2 h-6 w-11 rounded-full ' + (form.reward_accessories_only ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                    <span class="ml-2 text-sm font-medium uppercase" >{{ form.reward_accessories_only ? 'ON' : 'OFF' }}</span>
                  </label>
                </div>
              </div>
              
              <div class="w-full xl:w-1/4">
                <div class="input-wrapper flex xl:justify-end mt-3">
                  <button v-if="can_edit_membership_details" @click.prevent="save()" class="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest hover:bg-theme-green hover:text-white" for="">SAVE</button>
                </div>
              </div>
            </div>

            <div class="flex gap-3 xl:flex-row flex-col items-start mt-4 mb-4">
              <div class="w-full xl:w-1/4">
                <div class="input-wrapper ">
                  <label class="block text-white text-xs tracking-[0.4px]">Earnable Items</label>
                  <div class="text-white text-sm tracking-wider mt-2">{{ loyaltyProductCountObj.earnable_items }} {{ loyaltyProductCountObj.earnable_items > 1  ? 'Items' : 'Item' }} selected</div>
                </div>
              </div>
              <div class="w-full xl:w-1/4">
                <div class="input-wrapper flex xl:justify-left mt-3 mr-2">
                  <button v-if="can_edit_membership_details" @click.prevent="categoryWithproductObj.active = true" class="bg-white text-[#2BA66B] px-4 py-2 border-0 rounded cursor-pointer text-sm font-medium tracking-widest hover:bg-theme-green hover:text-white" for="">SELECT</button>
                </div>
              </div>
            </div>
          </template>

          <p v-else class="text-sm"> Loyalty Program is inactive or not set.</p>
        </template>

        <div v-if="loyaltyProgram && loyaltyProgram.id" :class="'flex content-main gap-5 ' + (action.component ? ' half-it' : '')">
          <div class="custom-full">
            <div class="mt-5 flex justify-between">
              <h3 class="text-[24px] text-white font-semibold">Points for Actions</h3>
              <mdicon @click="addUpdate({ component: 'Add', data: {} })" v-if="!action.component && can_edit_membership_details" size="32" name="plus" class="text-white bg-theme-green hover:bg-theme-darkgreen py-1 h-10 px-1 text-2xl border-0 rounded-md cursor-pointer"/>
            </div>
            <List v-if="loyaltyProgram && loyaltyProgram.id" :selectedCallback="selectedItem" :loyaltyProgram="loyaltyProgram" :clearComponent="clearComponent" :iscomponentactive="action.component ? true : false"/> 
          </div>
          <div :class="'w-full hidden-component'" v-if="action.component" >
            <component v-if="loyaltyProgram && loyaltyProgram.id" :is="action.component" :loyaltyProgram="{ id: loyaltyProgram.id }" :redeemingSetting="{ id: earningSetting.id, points_for_dollar: earningSetting.points_for_dollar  }" :item="action.data" :clearComponent="clearComponent"></component>
          </div>
        </div>
    </div>
  </div>

  <CategoryWithProductModal v-if="categoryWithproductObj.active && loyaltyProgram.id" :loyaltyProgramId="loyaltyProgram.id" :closeClick="closeCategoryWithProductModal" :actionClick="setCategoriesWithProduct"/>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import { useSnackbar } from "vue3-snackbar";
import Nav from "@/views/Membership/Program/Nav.vue";
import List from "@/views/Membership/Program/EarningPoints/List.vue";
import Add from "@/views/Membership/Program/EarningPoints/Add.vue";
import Update from "@/views/Membership/Program/EarningPoints/Update.vue";
import CategoryWithProductModal from '@/views/Membership/Program/EarningPoints/CategoryWithProductModal.vue';
import LoyaltyProgramApis from "@/controllers/LoyaltyProgramApis";
import LoyaltyEarnSettingApis from "@/controllers/LoyaltyEarnSettingApis";
import LoyaltyProgramProductApis from "@/controllers/LoyaltyProgramProductApis";

export default defineComponent({
  name: "MembershipProgramEarningPoints",
  components: {
    Nav,
    CategoryWithProductModal,
    List,
    Add,
    Update
  },

  setup() {
    const snackbar = useSnackbar();
    const form = ref({
      earn_on: {
        value: 'item',
        error_type: '',
        error_message: '',
        validations: ['required', 'min:3'],
      },
      points_per_dollar: {
        value: '',
        error_type: '',
        error_message: '',
        validations: ['required', 'numeric'],
      },
      min_purchase_amount: {
        value: '0',
        error_type: '',
        error_message: '',
        validations: [], // 'required_min_0', 'numeric'
      },
      reward_accessories_only: false,
      
    });
    const loyaltyProductCountObj = ref({ earnable_items: 0 });
    const categoryWithproductObj = ref({
      active: false,
    });
    const loyaltyProgram = <any>ref({});
    const earningSetting = <any>ref({});
    const action = ref<object>({
      component: '',
      data: {},
    });
    const loadingEarning = ref(false);

    return {
      action,
      form,
      snackbar,
      categoryWithproductObj,
      loyaltyProgram,
      earningSetting,
      loadingEarning,
      loyaltyProductCountObj
    };
  },

  computed: {

    /**
     * Edit restriction
     */
    can_edit_membership_details() {
      return Helpers.getMyPermission('can_edit_membership_details')
    },
    is_super_user() {
      return Helpers.isSuperUser();
    },
    
    ...mapGetters({
   
    }),
  },
 

  async mounted() {
    this.loadingEarning = true;
    let loyaltyProgramRes = await LoyaltyProgramApis.getProgramByCurrentActiveBusiness();
    if(loyaltyProgramRes.status == 200 || loyaltyProgramRes.status == 201) {
      this.loyaltyProgram = loyaltyProgramRes.data;
      this.fetchLoyaltyProductCount();
      let res = await LoyaltyEarnSettingApis.fetchSetting(loyaltyProgramRes.data.id);
     if(res.status == 200) {
        this.earningSetting = res.data;
        this.form.earn_on.value = res.data.earn_on
        this.form.points_per_dollar.value = res.data.points_per_dollar
        this.form.min_purchase_amount.value = res.data.min_purchase_amount
        this.form.reward_accessories_only = res.data.reward_accessories_only ? true : false
     }
    }
    this.loadingEarning = false;
  },

  methods: {

    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    /**
     * Save
     */
    async save() {
       // check first step 
      let validate = await this.validateFields(['earn_on', 'points_per_dollar']);
      if(!validate) {
        return ;
      }
      this.va_spinner(true);
      let data = {
        earn_on: this.form.earn_on.value,    
        points_per_dollar: this.form.points_per_dollar.value,
        min_purchase_amount: this.form.min_purchase_amount.value ? this.form.min_purchase_amount.value : 0,
        reward_accessories_only: this.form.reward_accessories_only ? true : false,
      }
      let res:any = {};
      let msg = '';
      if(this.earningSetting.id) {
        // update
        res = await LoyaltyEarnSettingApis.update(this.loyaltyProgram.id, data);
        msg = res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data)
      } else {
        // add
        res = await LoyaltyEarnSettingApis.create(this.loyaltyProgram.id, data);
        msg = res.status == 201 ? res.data.msg : Helpers.catchErrorMessage(res.response.data)
      }
      
      if(res.status == 200 || res.status == 201) {
        this.earningSetting = res.data;
      }
      

      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: msg,
        duration: 3000,
      })
    },


    /**
     * Close select category modal
     */
    closeCategoryWithProductModal() {
     this.categoryWithproductObj.active = false;
    },

    /**
     * Get data selected from category modal
     */
    async setCategoriesWithProduct(data) {
      this.va_spinner(true);
      let res = await LoyaltyEarnSettingApis.assignProducts(this.loyaltyProgram.id, data);
      this.va_spinner(false);
      if(res.status == 200) {
        this.closeCategoryWithProductModal();
        this.fetchLoyaltyProductCount();
      }
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.msg : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
      
    },

     /**
     * Clear action
     */
    clearComponent() {
      this.action = {
        component: '',
        data: {},
      };
      let activeItem = document.getElementsByClassName('active-row');
      if(activeItem.length > 0){
        activeItem[0].classList.remove("active-row");
      }
    },

    /**
     * Change add / update component
     */
    addUpdate(val: any) {
      this.action = val;
    },

    /**
     * Capture selected item
     */
    selectedItem(item) {
      this.addUpdate({
        component: 'Update', 
        data: item
      })
    },

    /**
     * Fetch loyalty prduct count
     */
    async fetchLoyaltyProductCount() {
      let loyaltyProgramProductCountRes = await LoyaltyProgramProductApis.programCount(this.loyaltyProgram.id);
      if(loyaltyProgramProductCountRes.status == 200) {
        this.loyaltyProductCountObj = loyaltyProgramProductCountRes.data;
      } else {
        this.loyaltyProductCountObj = { earnable_items: 0 };
      }
    },

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })

  },
});

</script>

